export const LoginError = {
  USERNAME_PASSWORD_REQUIRED: "username.password.required",
  USERNAME_REQUIRED: "username.required",
  PASSWORD_REQUIRED: "password.required",
};

export const WebLoginErrorMessage = {
  [LoginError.USERNAME_PASSWORD_REQUIRED]: "username_and_password_required",
  [LoginError.USERNAME_REQUIRED]: "login_username_required_error",
  [LoginError.PASSWORD_REQUIRED]: "login_password_required_error",
};
